import React from 'react'
import upperFirst from 'lodash/upperFirst'
import { compose } from 'recompose'
import ContentAdd from 'material-ui/svg-icons/content/add';
import Paper from 'material-ui/Paper'
import CmsApis from 'apis/cmsApis'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import { withRouter } from 'react-router'
import withFetchResources from 'hocs/bases/withFetchResources'
import withLoading from 'hocs/bases/withLoading'
import withDeleteResource from 'hocs/bases/withDeleteResource'
import withTempAction from 'hocs/bases/withTempAction'
import SubmitModal from 'components/modals/SubmitModal'
import Alert from 'components/modals/Alert'
import Container from 'components/Container'
import { routesByValue } from 'helpers/routesConstant'

const withViewAllPage = ({
  resourceName = {
    singular: '',
    plural: '',
  },
  getFetchAction,
  getDeleteAction,
}) => {
  const singularName = resourceName.singular
  const pluralName = resourceName.plural
  const ResourcesName = upperFirst(pluralName)
  const ResourceName = upperFirst(singularName)
  return (WrappedComponent) => compose(
    withFetchResources({
      resourceName: pluralName,
      getAction: getFetchAction || (() => CmsApis[`get${ResourcesName}`]),
      getSuccessData: ({ data }) => data,
    }),
    withLoading({
      getIsLoading: (props) => (
        props[`fetch${ResourcesName}Status`].isRequest ||
        props[`fetch${ResourcesName}Status`].isInitial
      ),
      getMessage: (props) => props[`fetch${ResourcesName}Status`].message,
    }),
    withDeleteResource({
      resourceName: singularName,
      getOnActionSuccess: (props) => (id) => {
        const { setResources, [pluralName]: resources } = props
        return setResources(resources.filter((item) => item.id !== id))
      },
      getAction: getDeleteAction || (() => CmsApis[`delete${ResourceName}ById`]),
    }),
    withTempAction(),
    withRouter,
  )(
    ({
      router,
      tempState,
      tempContent,
      onCloseTempState,
      onSubmitForm,
      submitAction,
      ...props
    }) => (
      <Container>
        <Paper className={'view-all'}>
          <WrappedComponent
            router={router}
            {...props}
            renderAddResourceButton={
              () => (
                <FloatingActionButton
                  mini
                  onTouchTap={() => router.push(routesByValue[`create${ResourceName}`].value)}
                >
                  <ContentAdd />
                </FloatingActionButton>
              )
            }
          />
          <Alert
            open={tempState}
            content={tempContent}
            onCancel={onCloseTempState}
            onSubmit={submitAction}
          />
        </Paper>
      </Container>
    ),
  )
}

export default withViewAllPage



// WEBPACK FOOTER //
// ./src/hocs/extends/withViewAllPage.js